export const HEADER_TYPES = {
   CENTER_TITLE_TYPE: 'centerTitleHeaderType',
   MARKETING_SITE_TYPE: 'marketingSiteHeaderType'
};
